import React from 'react';
import { Box, Paper, Skeleton, Stack } from '@/shared/ui';

const ReportPageSkeleton: React.FC = () => (
  <Stack spacing={2} sx={{ mt: 1 }}>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr 1fr' },
        gap: 2,
      }}
    >
      {[0, 1, 2].map((i) => (
        <Paper key={i} variant="outlined" elevation={0} sx={{ p: 2 }}>
          <Skeleton variant="text" width={96} height={16} sx={{ mb: 1 }} />
          <Skeleton variant="rounded" height={28} width="50%" />
        </Paper>
      ))}
    </Box>
    <Paper variant="outlined" elevation={0} sx={{ p: 2.5 }}>
      <Skeleton variant="text" width={140} height={24} sx={{ mb: 2 }} />
      <Skeleton variant="rounded" height={220} />
    </Paper>
  </Stack>
);

export default ReportPageSkeleton;
